/**
 * GPS travel map — shared constants (colors, time options).
 */

export const HOUR_OPTIONS = [
  { value: 6, label: 'Last 6 hours' },
  { value: 12, label: 'Last 12 hours' },
  { value: 24, label: 'Last 24 hours' },
  { value: 168, label: 'Last 7 days' },
  { value: 720, label: 'Last 30 days' },
];

/** Fixed palette for device paths (one color per device). */
export const DEVICE_COLORS = [
  '#2563eb', // blue
  '#16a34a', // green
  '#ea580c', // orange
  '#dc2626', // red
  '#9333ea', // purple
  '#0891b2', // cyan
  '#ca8a04', // yellow
  '#db2777', // pink
];

export function getDeviceColor(index) {
  return DEVICE_COLORS[index % DEVICE_COLORS.length];
}
